const environment = {
    local: {
        API_URL               : 'http://localhost:65000',
        ATTACHMENTS_URL       : '',
        FE_URL                : 'http://localhost:3000',
        COGNITO_DOMAIN_URL    : 'https://dev.auth.condenast.systrategy.com',
        COGNITO_SAML_PROVIDER : 'oktaDevIdp',
        APPLICATION_DOMAIN    : 'condenast.systrategy.com',
        ENV                   : 'Local',
        FORCE_MFA_TOTP        : true,
        MFA_ISSUER            : 'Hub-Dev-Condé Nast',
        CHECK_REFRESH_TOKEN   : 60000,
        REFRESH_TOKEN_INTERVAL: 1680000,
        DEFAULT_TIMEOUT_POPUPS: 5000,
        DAY_IN_SECONDS        : 86400,
        GUARD_BEFORE_EXPIRE   : 10,
        TOKEN_IS_GOING_EXPIRE : 30,
        HOME_PAGE             : '/home',
        PRIVS_TO_FIND         : ['P_ROOBEEK', 'P_PROVVIGIONI', 'P_CIRCULATION', 'P_AVB'],
        REACT_APP_USERPOOL_ID : 'eu-west-3_wB2OK1Dkl',
        REACT_APP_CLIENT_ID   : '4ugotf9115e3h7oet9hj5v6fon',
        PITAYA_CLIENT_ID      : '59gkj73btiahp32qnnnr93m9ru',
        DURIAN_CLIENT_ID      : '3serfde38hhcm2e9od53aakafs',
        ROOBEEK_CLIENT_ID     : '2apd9jkoondfn7me8t3erursok',
        CIRCULATION_URL       : 'https://dev-circulation.condenast.systrategy.com/login',
        SALES_COMM_URL        : 'https://dev-commissions.condenast.systrategy.com/login',
        ROOBEEK_URL           : 'https://dev-roobeek.condenast.systrategy.com/login',
        AVB_URL               : 'https://dev-avb.condenast.systrategy.com/login',
        DATAGRID_LICENSE      : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
    },
    dev: {
        API_URL               : 'https://backend.condenast.systrategy.com/ecf68ad0329ed9cf758b892808fb5d34bb268ceff4c5963511953a767c74c0fa',
        ATTACHMENTS_URL       : '',
        FE_URL                : 'https://dev.condenast.systrategy.com',
        COGNITO_DOMAIN_URL    : 'https://dev.auth.condenast.systrategy.com',
        COGNITO_SAML_PROVIDER : 'oktaDevIdp',
        APPLICATION_DOMAIN    : 'condenast.systrategy.com',
        ENV                   : 'Dev',
        FORCE_MFA_TOTP        : true,
        MFA_ISSUER            : 'Hub-Dev-Condé Nast',
        CHECK_REFRESH_TOKEN   : 60000,
        REFRESH_TOKEN_INTERVAL: 1680000,
        DEFAULT_TIMEOUT_POPUPS: 5000,
        DAY_IN_SECONDS        : 86400,
        GUARD_BEFORE_EXPIRE   : 10,
        TOKEN_IS_GOING_EXPIRE : 30,
        HOME_PAGE             : '/home',
        PRIVS_TO_FIND         : ['P_ROOBEEK', 'P_PROVVIGIONI', 'P_CIRCULATION', 'P_AVB'],
        REACT_APP_USERPOOL_ID : 'eu-west-3_wB2OK1Dkl',
        REACT_APP_CLIENT_ID   : '4ugotf9115e3h7oet9hj5v6fon',
        PITAYA_CLIENT_ID      : '59gkj73btiahp32qnnnr93m9ru',
        DURIAN_CLIENT_ID      : '3serfde38hhcm2e9od53aakafs',
        ROOBEEK_CLIENT_ID     : '2apd9jkoondfn7me8t3erursok',
        CIRCULATION_URL       : 'https://dev-circulation.condenast.systrategy.com/login',
        SALES_COMM_URL        : 'https://dev-commissions.condenast.systrategy.com/login',
        ROOBEEK_URL           : 'https://dev-roobeek.condenast.systrategy.com/login',
        AVB_URL               : 'https://dev-avb.condenast.systrategy.com/login',
        DATAGRID_LICENSE      : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
    },
    test: {
        API_URL               : 'https://backend.condenast.systrategy.com/55d8cf57cf31c5a6f8a142555643f5807d98073a960cc2e98b5000c21ded76df',
        ATTACHMENTS_URL       : '',
        FE_URL                : 'https://test.condenast.systrategy.com',
        COGNITO_DOMAIN_URL    : 'https://test.auth.condenast.systrategy.com',
        COGNITO_SAML_PROVIDER : 'OktaTestAcc',
        APPLICATION_DOMAIN    : 'condenast.systrategy.com',
        ENV                   : 'Test',
        FORCE_MFA_TOTP        : true,
        MFA_ISSUER            : 'Hub-Test-Condé Nast',
        CHECK_REFRESH_TOKEN   : 60000,
        REFRESH_TOKEN_INTERVAL: 3600000,
        DEFAULT_TIMEOUT_POPUPS: 5000,
        DAY_IN_SECONDS        : 86400,
        GUARD_BEFORE_EXPIRE   : 10,
        TOKEN_IS_GOING_EXPIRE : 30,
        HOME_PAGE             : '/home',
        PRIVS_TO_FIND         : ['P_ROOBEEK', 'P_PROVVIGIONI', 'P_CIRCULATION', 'P_AVB'],
        REACT_APP_USERPOOL_ID : 'eu-west-3_T5SEO0D1n',
        REACT_APP_CLIENT_ID   : '7cel10frpvrupubps9ioam5noe',
        PITAYA_CLIENT_ID      : '4nhltb6ic6u4djqna6g5m51cla',
        DURIAN_CLIENT_ID      : '45iud8iq8op300he3vm4vc5a9s',
        ROOBEEK_CLIENT_ID     : '6jja3d8rofdjd8l8nqqrvrt543',
        CIRCULATION_URL       : 'https://test-circulation.condenast.systrategy.com/login',
        SALES_COMM_URL        : 'https://test-commissions.condenast.systrategy.com/login',
        ROOBEEK_URL           : '',
        AVB_URL               : 'https://test-avb.condenast.systrategy.com/login',
        DATAGRID_LICENSE      : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
    },
    prod: {
        API_URL               : 'https://backend.condenast.systrategy.com/2666b926d255d7f5bc1f8bd2c360c4106b61682b44016998ba86fbef2b380029',
        ATTACHMENTS_URL       : '',
        FE_URL                : 'https://condenast.systrategy.com',
        COGNITO_DOMAIN_URL    : 'https://prod.auth.condenast.systrategy.com',
        COGNITO_SAML_PROVIDER : 'OktaCondenastProd',
        APPLICATION_DOMAIN    : 'condenast.systrategy.com',
        ENV                   : 'Prod',
        FORCE_MFA_TOTP        : true,
        MFA_ISSUER            : 'Hub-Prod-Condé Nast',
        CHECK_REFRESH_TOKEN   : 60000,
        REFRESH_TOKEN_INTERVAL: 3600000,
        DEFAULT_TIMEOUT_POPUPS: 5000,
        DAY_IN_SECONDS        : 86400,
        GUARD_BEFORE_EXPIRE   : 10,
        TOKEN_IS_GOING_EXPIRE : 30,
        HOME_PAGE             : '/home',
        PRIVS_TO_FIND         : ['P_ROOBEEK', 'P_PROVVIGIONI', 'P_CIRCULATION', 'P_AVB'],
        REACT_APP_USERPOOL_ID : 'eu-west-3_9bgvLYP7I',
        REACT_APP_CLIENT_ID   : '2sqjsa71208vsuqs9s1kur54sl',
        PITAYA_CLIENT_ID      : '4nhltb6ic6u4djqna6g5m51cla',
        DURIAN_CLIENT_ID      : '45iud8iq8op300he3vm4vc5a9s',
        ROOBEEK_CLIENT_ID     : '6jja3d8rofdjd8l8nqqrvrt543',
        CIRCULATION_URL       : 'https://circulation.condenast.systrategy.com/login',
        SALES_COMM_URL        : 'https://commissions.condenast.systrategy.com/login',
        ROOBEEK_URL           : 'https://roobeek.condenast.systrategy.com/login',
        AVB_URL               : 'https://avb.condenast.systrategy.com/login',
        DATAGRID_LICENSE      : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'        
    }
}

export default environment[process.env.REACT_APP_ENV || 'local'];